import { getDashboardAndWidgets } from '/src/features/dashboards/dashboard/service/dashboard-service';

import { widgetBasicSettings, widgetForApi } from '/src/features/widgets/edit/widget-helper';
export const actions = {
  /**
   * Method to fetch existing dashboard and widgets
   */
  async getDashboardAndWidgets({ commit }, pageUUID) {
    const { dashboard, widgetsByUuid } = await getDashboardAndWidgets(pageUUID, false);
    // If dashboard is un authorized on design
    if (dashboard.isUnauthorized) {
      navigateTo({ path: '/not-authorized' });
      return;
    }
    commit('setDashboard', dashboard);
    commit('setWidgets', widgetsByUuid);
  },
  /**
   * Method to save dashboard and will also delete widgets that are removed from the layout
   */
  async saveDashboardAndWidgets({ state, dispatch, commit }) {
    await dispatch('createDatasetWidgets');

    // Below change is needed because of change in format of layout json in the new library(grid-layout-plus) used.
    // For backward compatibility we are storing the layout json in old format only
    let oldLayoutJsonFormat = state.dashboard?.LayoutV2;
    if (state.dashboard?.LayoutV2?.length) {
      oldLayoutJsonFormat = state.dashboard.LayoutV2.map(({ type, i, ...rest }) => ({
        ...rest,
        i: { UUID: i, type }
      }));
    }
    const result = await dispatch('saveDashboard', { ...state.dashboard, LayoutV2: oldLayoutJsonFormat });
    commit('setIsLayoutChanged', false);
    /* If new layout was successfully saved then only delete widgets,
    as if update to layout fails it means changes in widgets won't reflect
    Case: Widget were deleted but could not be removed from dashboardLayout
    */
    if (result && state.deletedWidgets.length > 0) {
      await dispatch('deleteWidgets', state.deletedWidgets);
      commit('setDeletedWidgets');
    }
  },
  /**
   * Method to save dashboard
   */
  async saveDashboard(_ctx, dashboard) {
    try {
      let dashboardToSave = { ...dashboard };
      dashboardToSave.LayoutV2 = JSON.stringify(dashboardToSave.LayoutV2);
      dashboardToSave.PreloadFilters = JSON.stringify(dashboardToSave.PreloadFilters);
      await this.$axios.$post(`/api/pages/edit/${dashboardToSave.UUID}`, dashboardToSave);
      this.$toast.success(
        this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.save_success', {
          feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.dashboard')
        })
      );
      return true;
    } catch (error) {
      this.$toast.error(this.$errorFromResponse('admin.dashboards.manage.save_action', error));
      return false;
    }
  },
  /**
   * Method to configure widget. It will create widget if not created. Once widget is created also update created widget UUID in LayoutV2
   * then will navigate to configure widget page
   */
  async configureWidget({ state, dispatch, commit }, widget) {
    let widgetUuid;
    if (isNaN(widget.UUID)) {
      widgetUuid = widget.UUID;
    } else {
      widgetUuid = await dispatch('createWidget', {
        widget: widgetForApi({
          type: widget.type,
          Settings: widgetBasicSettings()[widget.type] || {},
          enableTitle: true
        }),
        dashboard: state.dashboard
      });
      commit('updateWidgetUuid', { oldUuid: widget.UUID, newUuid: widgetUuid });
    }
    if (state.isLayoutChanged) {
      await dispatch('saveDashboardAndWidgets', { dashboard: state.dashboard, deletedWidgets: state.deletedWidgets });
    }
    if (widgetUuid) {
      navigateTo({
        path: `/admin/dashboards/design/${state.dashboard.UUID}/${widgetUuid}`
      });
    }
  },
  /**
   * Method to create new widget. It will return UUID of created widget
   */
  async createWidget(_ctx, { widget, dashboard }) {
    try {
      let widgetToCreate = { title: 'New widget', pageId: dashboard.ID, PageRef: dashboard.UUID, ...widget }; //kept pageId for backward compatibility
      const createdWidget = await this.$axios.$post(`/api/v2/widgets/create`, widgetToCreate);
      return createdWidget.UUID;
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.creating_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.widgets')
          }),
          error
        )
      );
    }
    return null;
  },
  /**
   * Method to delete widgets
   */
  async deleteWidgets(_ctx, deletedWidgets) {
    try {
      await this.$axios.$delete(`/api/widgets?UUIDs=${deletedWidgets}`);
    } catch (error) {
      this.$toast.error(
        this.$errorFromResponse(
          this.vueApp.$nuxt.$i18n.global.t('admin.dynamic_labels.deleting_action', {
            feature: this.vueApp.$nuxt.$i18n.global.t('admin.feature.widgets')
          }),
          error
        )
      );
    }
  },

  /**
   * Create dataset widgets.
   * Dataset widget has no configuration so creating widget when dashboard is saved.
   */
  async createDatasetWidgets({ state, dispatch, commit }) {
    const widgets = [];
    let widgetUUID;
    Object.keys(state.widgetsByUUID)
      .filter((key) => state.widgetsByUUID[key].type === 'Data Set')
      .forEach((key) => {
        widgets.push(state.widgetsByUUID[key]);
      });

    if (!widgets.length) {
      return;
    }

    /**
     * Create datasets widgets.
     */
    for (let widget of widgets) {
      if (isNaN(widget.UUID)) {
        return;
      }
      widgetUUID = await dispatch('createWidget', {
        widget: widgetForApi({
          ...widget,
          Settings: {}
        }),
        dashboard: state.dashboard
      });
      /**
       * Update state property with configured as true.
       */
      commit('updateWidgetUuid', {
        oldUuid: widget.UUID,
        newUuid: widgetUUID,
        IsConfigured: true
      });
    }
  }
};
